import React from 'react';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {SHARED_ANCHOR_NODE_CONSTRAINTS_DESCENDANTS} from '@packages/systems/core/constants/SharedConstraintRules';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {NODE_TYPE_COMMERCE_CART_CLOSE_LINK} from '@packages/systems/commerce/constants';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const CommerceCartCloseLink = Atom.createRender(
  ({data, attributes, classes, generateAttributes, renderChild}) => (
    <a
      {...generateAttributes(attributes, classes)}
      role="button"
      aria-label="Close cart"
      data-node-type={NODE_TYPE_COMMERCE_CART_CLOSE_LINK}
    >
      {getChildren(data).map((child: EvaluatedNodeData) => renderChild(child))}
    </a>
  )
);

const config = createIntegratedAtom({
  displayName: 'Close Button',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Button')),
  },
  showEmpty: false,
  constraints: {
    ancestors: [{is: 'CommerceCartHeader', rule: 'ExactlyOne'}],
    descendants: SHARED_ANCHOR_NODE_CONSTRAINTS_DESCENDANTS,
  },
  style: {
    base: {
      main: {
        noPseudo: {
          width: px(16),
          height: px(16),
        },
      },
    },
  },
  render: CommerceCartCloseLink,
  fields: {
    children: TListOfElement,
  },
});

export default config;
